<template>
  <div>
    <b-row>
      <b-col cols="4">
        <vs-card>
          <b-row style="margin-top: 8px">
            <b-col cols="4" align-self="center">
              <b-form-group :label="$t('RoleName')" label-for="h-first-name">
              </b-form-group>
            </b-col>
            <b-col cols="8">
              <b-form-input size="sm" id="h-first-name" v-model="roleName" name="stock_name" />
            </b-col>
          </b-row>

          <div slot="footer">
            <vs-row vs-justify="flex-end">
              <b-button style="background-color: #28C76F; border-color:#28C76F;" v-on:click="addRole">
                <Icon style="margin-right: 5px" icon="mdi:content-save-check-outline" width="20" height="20"
                  v-b-tooltip.hover.bottom="$t('Save')" /> {{ $t('Save') }}
              </b-button>
            </vs-row>
          </div>
        </vs-card>
      </b-col>
      <b-col cols="8">
        <vs-card>
          <ag-grid-vue style="width: 100%; height: 300px" class="ag-theme-alpine" :defaultColDef="defaultColDef"
            :columnDefs="columnDefs" :rowData="listeRole" :localeText="localeText" :rowSelection="rowSelection"
            @grid-ready="onGridReady" @first-data-rendered="onFirstDataRendered" :suppressCopyRowsToClipboard="true">
          </ag-grid-vue>
        </vs-card>
      </b-col>
    </b-row>
  </div>
</template>
<script>
import { AgGridVue } from "ag-grid-vue";
import "ag-grid-community/dist/styles/ag-grid.css";
import "ag-grid-community/dist/styles/ag-theme-alpine.css";
import "ag-grid-enterprise";
import { Icon } from "@iconify/vue2";
import i18nData from "../../../i18n/i18nData";
export default {
  components: { Icon, AgGridVue },
  data() {
    return {
      localLanguageJson: [],
      rowSelection: null,
      rowData: null,
      columnDefs: null,
      roleName: "",
      roleId: "",
      defaultColDef: {
        sortable: true,
        resizable: true
      },
      listeRole: ""
    }
  },
  methods: {
    listRole() {
      const vs = this.$vs;
      this.accCostumer = [];

      this.$store.dispatch("role/listRole").then(response => { 
        // let costumerList = JSON.parse(response.json);
        if (response.success == true) {
          this.listeRole = this.$store.state.role.Role;
          console.log(this.listeRole)
        } else
          vs.notify({
            text: response.message,
            iconPack: "feather",
            icon: "icon-alert-circle",
            color: "success",
            position: "top-center",
            fixed: true
          });
      });
    },
    addRole() { },
    onGridReady(params) {
      this.gridApi = params.api;
      this.gridColumnApi = params.columnApi;
    },
    onFirstDataRendered(params) {
      params.api.sizeColumnsToFit();
    },
  },
  created() { this.rowSelection = "single"; this.listRole(); },
  computed: {
    localeText() {
      let localLanguage = this.$i18n.locale;
      console.log(i18nData[localLanguage])
      this.localLanguageJson = i18nData[localLanguage]
      return i18nData[localLanguage];
    },
  }
}
</script>
